import { useMemo } from "react";

function useApiUrl(path?: string[]): string {
  return useMemo(() => path ? path.join("/") : "/", [path]);
}

export default useApiUrl;
